import {AuthService} from 'src/app/auth/auth.service';

export function appInitializer(authenticationService: AuthService) {
  return () =>
    new Promise((resolve) => {
      if (!navigator.onLine) {
        resolve('');
        return;
      }

      if (authenticationService.user) {
        authenticationService.refreshToken().subscribe({
          next: () => {
            // Intentionally empty: success case resolves on completion.
          },
          error: () => resolve(''),
          complete: () => resolve(''),
        });
      } else {
        resolve('');
      }
    });
}
